import { computed } from 'vue'
import { useLang } from '../store.mjs'
import data from './data.mjs'

function build(index){
  let map = {}
  data.forEach((i) => {
    map[i[0]] = i[index]
  })
  return map
}

const langs = {
  zh: build(0),
  en: build(1)
}

const [lang, setLang] = useLang()

export const t = (msg) => {
  return langs[lang.value][msg]?langs[lang.value][msg]:msg
}

/** 在文案中替换 `{key}` 占位符（与 data.mjs 中文 key 配套使用） */
export const tf = (templateKey, params = {}) => {
  let s = t(templateKey)
  if (!params || typeof params !== 'object') return s
  for (const [k, val] of Object.entries(params)) {
    const needle = `{${k}}`
    s = s.split(needle).join(String(val))
  }
  return s
}